// extracted by mini-css-extract-plugin
export default {"ftitle":"footer_ftitle__3FaW0","icons":"footer_icons__00kbw","redes":"footer_redes__DeXFo","iso":"footer_iso__SheWC","mail":"footer_mail__F5Iof"};